export const FilterOperator = {
  AllOf: 'all_of',
  AnyOf: 'any_of',
  NoneOf: 'none_of',
  Contains: 'contains',
  Prefix: 'prefix',
  Equals: 'equals',
  Exists: 'exists',
  NotExists: 'not_exists',
} as const

export type FilterOperator = (typeof FilterOperator)[keyof typeof FilterOperator]
